import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import DataTableRepository from "../Repositories/DataTableRepository";

class DataTableBloc {
  rowtableChannel = new Subject();
  workUnitChannel = new Subject();
  listAtasanChannel = new Subject();
  exportChannel = new Subject();
  checkSkpChannel = new Subject();
  checkSkpWithoutModalChannel = new Subject();
  checkVerifikasiChannel = new Subject();
  previewUploadChannel = new Subject();
  deleteChannel = new Subject();
  repository = new DataTableRepository();

  constructor() {
    this.rowtableChannel.next({ status: apiResponse.INITIAL });
    this.workUnitChannel.next({ status: apiResponse.INITIAL });
    this.listAtasanChannel.next({ status: apiResponse.INITIAL });
    this.exportChannel.next({ status: apiResponse.INITIAL });
    this.checkSkpChannel.next({ status: apiResponse.INITIAL });
    this.checkSkpWithoutModalChannel.next({ status: apiResponse.INITIAL });
    this.checkVerifikasiChannel.next({ status: apiResponse.INITIAL });
    this.previewUploadChannel.next({ status: apiResponse.INITIAL });
    this.deleteChannel.next({ status: apiResponse.INITIAL });
  }

  fetchRowTable = async (query, cancelToken) => {
    this.rowtableChannel.next({ status: apiResponse.LOADING });
    try {
      await this.repository
        .fetchRowTable(query, cancelToken)
        .then((result) => {
          this.rowtableChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.rowtableChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchWorkUnit = async (query, cancelToken) => {
    this.workUnitChannel.next({ status: apiResponse.LOADING });
    try {
      await this.repository
        .fetchWorkUnit(query, cancelToken)
        .then((result) => {
          this.workUnitChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.workUnitChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchAtasan = async (query, cancelToken) => {
    this.listAtasanChannel.next({ status: apiResponse.LOADING });
    try {
      await this.repository
        .fetchAtasan(query, cancelToken)
        .then((result) => {
          this.listAtasanChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.listAtasanChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchExport = async (query) => {
    try {
      this.exportChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchExport(query)
        .then((result) => {
          this.exportChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.exportChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "channel unsubscriber");
    }
  };

  fetchCheckSkp = async (query) => {
    try {
      this.checkSkpChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchCheckSkp(query)
        .then((result) => {
          this.checkSkpChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.checkSkpChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "channel unsubscriber");
    }
  };

  fetchCheckSkpWithoutModal = async (query) => {
    try {
      this.checkSkpWithoutModalChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchCheckSkp(query)
        .then((result) => {
          this.checkSkpWithoutModalChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.checkSkpWithoutModalChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "channel unsubscriber");
    }
  };

  fetchCheckVerifikasi = async (query) => {
    try {
      this.checkVerifikasiChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchCheckVerifikasi(query)
        .then((result) => {
          this.checkVerifikasiChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.checkVerifikasiChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "channel unsubscriber");
    }
  };

  fetchPreviewUpload = async (query) => {
    this.previewUploadChannel.next({ status: apiResponse.LOADING });
    try {
      await this.repository
        .fetchPreviewUpload(query)
        .then((result) => {
          this.previewUploadChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.previewUploadChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchDelete = async (query) => {
    this.deleteChannel.next({ status: apiResponse.LOADING });
    try {
      await this.repository
        .fetchDelete(query)
        .then((result) => {
          this.deleteChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.deleteChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };
}

export default DataTableBloc;
